import base from "../baseurl";
import token from "../getTk";

const Create = async (name, address, capacity) => {
  console.log(name, address, capacity);
  const tokenA = token.get();
  const api = base.extend({
    hooks: {
      beforeRequest: [
        (request) => {
          request.headers.set("jwt", `${tokenA}`);
        },
      ],
    },
  });
  const create = await api
    .post("campuses/create", {
      timeout: false,
      json: {
        name,
        address,
        capacity,
      },
    })
    .json();
  console.log(create);
  return create;
};

export default Create;
